import React, { useContext } from "react";
import { ChatContext } from "../../../../contexts/ChatContext";
import { ScreenContext } from "../../../../contexts/ScreenContext";

export default function EventInviteButton({
  isInviting,
  isInvalidInvite,
  handleInviteToPrivateChatroom,
  getSelectedUsers,
  isMobile = false,
}) {

  const { setinMobileView } = useContext(ScreenContext);
  const { setInitChatWindow } = useContext(ChatContext);
  
  return (
    <button
      type="button"
      className="create-chat-btn col-12 mt-3 text-white d-md-inline d-block"
      disabled={isInviting || isInvalidInvite}
      onClick={(e) => {
        e.preventDefault();
        handleInviteToPrivateChatroom();
        
        if (isMobile) {
          setinMobileView("users");
          setInitChatWindow(true);
        }

      }}
      style={{
        fontSize: "14px",
        fontWeight:"500",
        height: "44px",
      }}
    >
      {!isInviting && <>Create Chat Group ({getSelectedUsers().length})</>}
      {isInviting && <>Creating...</>}
    </button>
  );
}
